/*
 * $Id:: ClickableCard.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as LaunchIcon } from '../../assets/images/launch_24px.svg';
import { t } from '../../providers';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    clickableCard: {
        border: 'none',
        background: '#FFFFFF',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04)',
        borderRadius: '2px',
        width: '281px',
        height: 'fit-content',
        margin: '20px 30px 0 0',
        padding: '10px 24px',
        position: 'relative',
        textDecoration: 'none',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '&:hover': {
            cursor: 'pointer',
        },
        '@media (max-width:960px)': {
            width: '200px',
        },
        '@media (max-width:400px)': {
            width: '100%',
        },
        '@media (max-width:660px)': {
            width: '100%',
            margin: '20px 0px 0 0',
        },
    },
    title: {
        fontSize: '0.625rem',
        lineHeight: '15px',
        textTransform: 'uppercase',
        color: theme.palette.text.label,
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: '700',
        textAlign: 'start',
        '@media (max-width:600px)': {
            float: 'left',
        },
    },
    description: {
        fontSize: '0.75rem',
        lineHeight: '133%',
        color: theme.palette.text.chipgrey,
        margin: '5px 0 8px 0',
        letterSpacing: '-0.2px',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: '400',
        textAlign: 'start',
        '@media (max-width:600px)': {
            float: 'left',
        },
    },
    externalPathIcon: {
        textAlign: 'right',
        color: '#ff0000',
    },
}));

const ClickableCard = ({ item = {}, navigateTo }) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            {Object.keys(item).length > 0 && (
                <Link
                    role="link"
                    component="button"
                    id={`card-${item.title.replace('.', '-')}`}
                    className={classes.clickableCard}
                    onClick={(e) => navigateTo(e, item.path, item.externalPath, item.requiredProfileDetails)}>
                    {item.title && <div className={classes.title}>{t(item.title)}</div>}
                    {item.description && <div className={classes.description}>{t(item.description)}</div>}
                    {item.externalPath && (
                        <div className={classes.externalPathIcon}>
                            <LaunchIcon fill="#ff0000" role="img" focusable="false" aria-label={t('open.new.tab')} />
                        </div>
                    )}
                </Link>
            )}
        </React.Fragment>
    );
};

export default ClickableCard;
